/**
 * Created by Jie Gao on 2019-01-22.
 */
import {
    IPickAndClickConfig,
    PickAndClickController
} from "@nolimitcity/slot-game/bin/core/pickandclick/PickAndClickController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StarStruckParsedGameData} from "../server/data/StarStruckParsedGameData";
import {StarStruckParsedInitData} from "../server/data/StarStruckParsedInitData";
import {StarStruckSoundConfig} from "../StarStruckSoundConfig";
import {StarStruckPickNClickScreen} from "./StarStruckPickNClickScreen";

export class StarStruckPickNClick extends PickAndClickController {
    private _gameView:StarStruckPickNClickScreen;
    private _isBigWin:boolean = false;

    constructor(name:string, config:IPickAndClickConfig) {
        super(name, config, true);
        this._gameView = <StarStruckPickNClickScreen><unknown>this._view;
    }

    protected parseFeatureGameData(data:StarStruckParsedGameData):void {
        this._isBigWin = data.isBigWin;
    }

    protected calculateIsTriggered(data:StarStruckParsedGameData):boolean {
        return data.nextMode === "STAR_PICK_SELECTION";
    }

    protected calculateIsRestoreTriggered(data:StarStruckParsedInitData):boolean {
        return false;
    }

    protected parseButtonConfigs(data:StarStruckParsedGameData):number[] {
        return data.bonusValues;
    }

    protected onButtonClick(index:number):void {
        SlotGame.sound.playEffect(StarStruckSoundConfig.instance.BONUS_STAR_PICK);

        // This will turn off Autoplay if in restricted jurisdiction
        if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
            SlotGame.autoPlay.turnOffAutoplayOnBonus();
        }

        super.onButtonClick(index);
    }

    protected show(isRestoreSelected:boolean):void {
        if(this._isBigWin) {
            this._gameView.addDelayToStart();
        }
        super.show(isRestoreSelected);
        this._gameView.resetDelay();
    }
}